<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <div
        id="404"
        class="display-4 text-center mt-n12"
      >
        404
      </div>
      <v-col
        cols="12"
        class="text-center"
      >
        <v-btn
          text
          color="primary"
          @click="goToLogin"
        >
          Back to login page
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  methods: {
    ...mapActions('account', [
      'logout',
    ]),

    ...mapMutations('account', [
      'logoutUser',
    ]),

    async goToLogin() {
      try {
        await this.logout();
        window.location.href = process.env.VUE_APP_CAS_CLIENT;
      } catch (error) {
        console.log(error);
        // Than keep going logout process
        this.logoutUser();
        window.location.href = process.env.VUE_APP_CAS_CLIENT;
      }
    },
  },
};
</script>
